import React, { useEffect, useRef } from "react";
import * as MKPlayerSDK from "@mediakind/mkplayer";
import "@mediakind/mkplayer/mkplayer-ui.css";
import { useDispatch } from "react-redux";
import { usePlayerConfig } from "../../../hooks/usePlayerConfig";
import { MKPLAYER_LICENSE_KEY } from "../../../utils/apiConstants";

function VideoPlayer({
  mediaKindToken,
  setMediaKindToken,
  videoUrl,
  isPlayedFromLocal,
  type,
}) {
  const dispatch = useDispatch();
  const videoElement = useRef(null);
  let player = null;
  const { playerConfig, sourceConfig } = usePlayerConfig(
    videoUrl,
    mediaKindToken?.Authorization
  );

  const createVideoPlayer = async () => {
    const mkPlayerConfig = playerConfig;
    const mkSourceConfig = sourceConfig;

    if (MKPlayerSDK) {
      if (player) {
        await player?.unload?.();
        player = null;
      }

      player = new MKPlayerSDK.MKPlayer(videoElement?.current, mkPlayerConfig);

      player
        ?.load(mkSourceConfig)
        .then(() => {
          let videoQuality = player.getAvailableVideoQualities();
          let videoQualityLastElement = videoQuality.slice(-1);
          player.setVideoQuality(videoQualityLastElement[0]?.id);
        })
        .catch((error) => {
          console.error("An error occurred while loading the source!");
        });
    } else {
      console.log("::: MKPlayer SDK not initiated yet :::");
    }
  };

  const createHTML5VideoPlayer = () => {
    // debugger;
    const videoPlayer = videoElement?.current;
    videoPlayer.src = videoUrl;
    videoPlayer.type = type; // Assuming the local video file is in MP4 format
    // videoPlayer?.play();
  };

  useEffect(() => {
    if (mediaKindToken) createVideoPlayer();
    else if (isPlayedFromLocal) createHTML5VideoPlayer();
    return () => {
      if (player) {
        player?.destroy();
        setMediaKindToken("");
      }
    };
  }, [mediaKindToken, dispatch]);

  return (
    <>
      {isPlayedFromLocal ? (
        <video
          className="html5-video-player"
          controls
          ref={videoElement}
          style={{
            width: "100%",
            height: "100%",
          }}
          tabIndex="0"
        />
      ) : (
        <div ref={videoElement} id="video-container"></div>
      )}
      ;
    </>
  );
}

export default VideoPlayer;
